import { Routes } from '@angular/router';
import { partnerGuard } from '@app/core/guards/partner-guard-guard';

/**
 * Route group for the Execution Partner feature — the public landing/apply
 * flow, plus the guarded partner dashboard. Lazy-loaded as its own chunk from
 * app.routes.ts via a single loadChildren entry (see the hookup there).
 *
 * Public (no guard): '', 'apply', 'applied' — anyone can view the pitch and
 * apply without being logged in as a partner yet.
 *
 * Guarded (partnerGuard — approved Execution Partners only): 'dashboard' and
 * everything under it.
 *
 * NOTE: the admin review queue is deliberately NOT part of this group — it
 * lives under the existing admin/* routes in app.routes.ts, guarded by
 * adminCanMatch/adminCanActivate like admin/collaborators, not partnerGuard.
 * Applicants aren't partners yet, so admin's approval screen has nothing to
 * do with the partner-only guard below.
 */
export const PARTNER_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./landing/partner-landing/partner-landing').then((m) => m.PartnerLanding),
    title: 'Become an Execution Partner | Angularize',
  },
  {
    path: 'apply',
    loadComponent: () =>
      import('./apply/partner-apply/partner-apply').then((m) => m.PartnerApply),
    title: 'Apply | Angularize',
  },
  {
    path: 'applied',
    loadComponent: () =>
      import('./applied/partner-applied/partner-applied').then((m) => m.PartnerApplied),
    title: 'Application received | Angularize',
  },
  {
    path: 'dashboard',
    canActivate: [partnerGuard],
    loadComponent: () =>
      import('./dashboard/partner-shell/partner-shell/partner-shell').then((m) => m.PartnerShell),
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./dashboard/my-work/partner-my-work/partner-my-work').then((m) => m.PartnerMyWork),
        title: 'My work | Angularize',
      },
      {
        path: 'projects/:id',
        loadComponent: () =>
          import('./dashboard/project-view/partner-project-view/partner-project-view').then(
            (m) => m.PartnerProjectView,
          ),
        title: 'Project | Angularize',
      },
      {
        path: 'earnings',
        loadComponent: () =>
          import('./dashboard/earnings/partner-earnings/partner-earnings').then((m) => m.PartnerEarnings),
        title: 'Earnings | Angularize',
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./dashboard/profile/partner-profile/partner-profile').then((m) => m.PartnerProfile),
        title: 'My profile | Angularize',
      },
    ],
  },
];